import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { State } from '../../reducers';
import { PaymentTerm } from '@cemex-core/cmx-api';
import { getOneClickPayments } from '../../selectors/one-click-payments.selector';
import { OneClickSelectPaymentsAction } from '../../actions/one-click-payments.actions';

@Injectable()
export class OneClickSyncPayment implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: PaymentTerm, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOneClickPayments),
        filter((payments) => !!payments.length),
        take(1),
      )
      .subscribe((product) => {
        if (value) {
          this.store.dispatch(new OneClickSelectPaymentsAction(value, form.mapItem['index']));
        }
      });
  }
}
